import React, { FunctionComponent } from 'react';
import { Row } from '../layout';
import {
  Container,
  Content,
  Footer,
  HeroImage,
  Logo,
  Row1,
  Row2,
  Row3,
  Row4,
  Row5,
  Row6,
  Row7,
} from './PropertyPlaceholder.style';

interface Props {
  hideFooter?: boolean;
}

const PropertyPlaceholder: FunctionComponent<Props> = (props) => {
  return (
    <Container data-testid="property-placeholder">
      <HeroImage />

      <Content>
        <Row1 />
        <Row2 />
        <Row3 />

        <Row4 />
        <Row5 />
      </Content>

      {!props.hideFooter && (
        <Footer>
          <Row mt={10}>
            <Logo />

            <div>
              <Row6 />
              <Row7 />
            </div>
          </Row>
        </Footer>
      )}
    </Container>
  );
};

export default PropertyPlaceholder;
